/** @jsxImportSource @emotion/react */
import { Asterisk } from '@shared/react-ui-core';
import { motion } from 'framer-motion';
import Imgix from 'react-imgix';
import { H2 } from '../../Typography';
import useStyle from './style';

const FasterResponse: React.FC = () => {
  const { componentWrapper, stepsWrapper, stepStyle, subText } = useStyle();

  const steps = [
    {
      image:
        'https://www.datocms-assets.com/10154/1686166653-glassbreak-detected.png',
      step: 'We’ll send you a text message so you can quickly confirm or cancel your alarm from your phone.',
    },
    {
      image:
        'https://www.datocms-assets.com/10154/1680543223-is-everything-ok.png',
      step: 'Next, one of our trained professionals will give you a call to make sure you’re ok.',
    },
    {
      image:
        'https://www.datocms-assets.com/10154/1680543218-ems-is-on-their-way.png',
      step: 'If you confirm your emergency (or if we can’t get hold of you right away), we’ll send responders your way.',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.125,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25, transition: { type: 'spring' } },
    show: { opacity: 1, y: 0, transition: { type: 'spring' } },
  };

  return (
    <div css={componentWrapper}>
      <H2>
        Faster response. Fewer false alarms.
        <Asterisk asteriskClassname="w-0 border-none bg-transparent">
          *When compared to systems without RapidSOS integration and text
          notifications as of Aug 2024.
        </Asterisk>
      </H2>
      <p css={subText}>
        Cove's Alarm Response with RapidSOS means we’ll confirm your emergency
        and get help on the way as quickly as 30 seconds.
      </p>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        css={stepsWrapper}
      >
        {steps.map((step, stepIndex) => (
          <motion.div
            key={`faster-step-${stepIndex}`}
            variants={item}
            css={stepStyle}
          >
            <Imgix
              src={step.image}
              htmlAttributes={{ alt: step.step }}
              width={413}
              height={223}
            />
            <p>{step.step}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default FasterResponse;
